export default {"src":"/_next/static/media/parking-icon.02d60046.svg","height":57,"width":101,"blurWidth":0,"blurHeight":0};